import { NestedHome, NestedSearch } from "@habity/types";

export const getRelatedHomesFilters = (home: NestedHome) => {
  const { address, id, price } = home;
  const {
    category,
    rooms,
    longitude,
    latitude,
    living_space,
    municipality_id,
    area,
  } = address || {};

  const filters: Partial<NestedSearch> = {
    statuses: ["soon_for_sale", "for_sale", "premarket", "seller_claimed"],
    longitude,
    latitude,
    price_min: price ? Math.round(price - price * 0.2) : undefined,
    price_max: price ? Math.round(price + price * 0.2) : undefined,
    rooms_min: rooms && rooms <= 5 ? rooms - 1 : undefined,
    rooms_max: rooms && rooms <= 5 ? rooms + 1 : undefined,
    living_space_min: living_space
      ? Math.round(living_space - living_space * 0.3)
      : undefined,
    living_space_max: living_space
      ? Math.round(living_space + living_space * 0.3)
      : undefined,
    categories: [category],
    ignore_home_ids: [id],
    areaIds: area?.id ? [area.id] : undefined,
    municipalityIds: municipality_id ? [municipality_id] : undefined,
  };
  return filters;
};
